/*
 * @Author: edvardchen
 * @Date:   2016-08-09 10:44:30
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-08-16 17:30:50
 */

export default {
  viewWidth: 320, // 渲染宽度
  IMMEDIATE_IMG_COUNT: 2, // 头几张图片不懒加载
  image: {
    minWidth: 10, // 过滤小图标
    big: {
      width: 240,
      height: 100
    }
  }
};



// WEBPACK FOOTER //
// ./src/defaultOptions.js